import { Box, FormControl } from '@mui/material'
import { ReactElement, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import SearchInAPIAndMultiSelectInput from '../../../Common/SearchInAPIAndMultiSelectInput'
import { fetchBusinessRuleSetsOnly } from '../../../../services/entityInstanceServices'

interface BusinessRulesetAttributeProps {
    label: string
    id: string
    value: any
    onChange: any
    errorMessage?: string
    required?: boolean
    disabled?: boolean
    templateId: string
    orgId: string
}

const BusinessRulesetAttribute = (
    props: BusinessRulesetAttributeProps,
): ReactElement => {
    const {
        label,
        id,
        value,
        onChange,
        errorMessage,
        required,
        disabled,
        templateId,
        orgId,
    } = props
    const { t } = useTranslation()

    const [recordsList, setRecordsList] = useState<any[]>([])

    const [selectedValues, setSelectedValues] = useState<any[]>([])

    const [searchText, setSearchText] = useState<string>('')

    const [pageNumber, setPageNumber] = useState<number>(1)

    const [hasMore, setHasMore] = useState<boolean>(false)

    const [isFetching, setIsFetching] = useState(false)

    useEffect(() => {
        if (value) {
            setSelectedValues(value as any[])
        }
    }, [value])

    useEffect(() => {
        if (templateId && orgId) {
            setIsFetching(pageNumber === 1)
            const getRecords = async () => {
                const queryParams = {
                    pageNumber,
                    pageSize: 30,
                    searchText: searchText?.trim(),
                }
                try {
                    const businessRulesResult = await fetchBusinessRuleSetsOnly(
                        orgId,
                        templateId,
                        queryParams,
                    )

                    setRecordsList((prev) =>
                        pageNumber === 1
                            ? businessRulesResult?.ruleSets || []
                            : [
                                  ...prev,
                                  ...(businessRulesResult?.ruleSets || []),
                              ],
                    )
                    setHasMore(businessRulesResult?.ruleSets?.length === 30)
                } finally {
                    setIsFetching(false)
                }
            }
            getRecords()
        }
    }, [pageNumber, searchText, templateId, orgId])

    const onSelectRecords = (id: string, items: any) => {
        onChangeRecord(id, items)
    }
    const onSearch = (id: string, text: any) => {
        setSearchText(text)
        setPageNumber(1)
    }

    const handleFetchNextPage = () => {
        if (!isFetching && hasMore) {
            setPageNumber((prev) => prev + 1)
        }
    }

    const onChangeRecord = (id: string, selectedList: any[]) => {
        setSelectedValues(selectedList)
        onChange(id, selectedList)
    }
    return (
        <Box>
            <Box>
                <FormControl fullWidth disabled={!!disabled} size="small">
                    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                        <Box
                            sx={{
                                width: ' 100%',
                                maxWidth: `100%`,
                            }}
                        >
                            <SearchInAPIAndMultiSelectInput
                                id={id}
                                label={label}
                                placeholder={t('selectLabel', { label })}
                                required={required}
                                value={selectedValues}
                                onSelect={onSelectRecords}
                                list={recordsList || []}
                                errorMessage={
                                    !selectedValues.length && errorMessage
                                        ? errorMessage
                                        : ''
                                }
                                disabled={disabled}
                                onSearch={onSearch}
                                onFetchNextPage={handleFetchNextPage}
                                hasMore={hasMore}
                                isFetching={isFetching}
                            />
                        </Box>
                    </Box>
                </FormControl>
            </Box>
        </Box>
    )
}

export default BusinessRulesetAttribute
